import SelectModelType from './SelectModelType';
import SearchModelModule from './SearchModelModule';
import SearchModelKey from './SearchModelKey';
import SelectModelVersion from './SelectModelVersion';
import SelectModelStatus from './SelectModelStatus';

export default function GridHeaderRow() {
  return (
    <>
      <SelectModelType />
      <SearchModelModule />
      <SearchModelKey />
      <SelectModelVersion />
      <SelectModelStatus />
      <div />
      <div />
    </>
  );
}
